module.exports = {
  apiHost: "https://api.arven.sensoreal.app",
  assetsHost: "https://assets.arven.sensoreal.app",
  brandName: "Arven",

  formTemplate: "default",

  currency: {
    locale: "en-AU",
    code: "AUD",
  },

  langs: [{ code: "en", dir: "ltr" }],

  style: {
    primaryColor: "#000",
    textColor: "#fff",
    backgroundColor: "#fff",
    font: "Nexa",
    backgroundGradient: "",
    secondaryFont: "",
    secondaryFontStylesheet: "",
  },

  header: {
    text: {
      en: "Your Arven Selections",
      ar: "",
    },

    logo: false,
    logoMaxWidth: "",
    logoMaxHeight: "",
    companyLogo: false,
    companyLogoMaxWidth: "",
    companyLogoMaxHeight: "",
    titleFontSize: "",

    color: "#fff",
  },

  footerLogo: false,
  footerLogoPosition: "",
  footerLogoMaxWidth: "",

  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
  },

  contact: {
    website: "",
    address: "",
    phone: "",
    email: "",
  },
};
